// extracted by mini-css-extract-plugin
export default {"orderHistoryOverview":"Qt-z","errorMsg":"Rt-z"};